import ListItem from '@trilogy-ds/react/lib/components/list/item/ListItem';
/**
 * ListItem Component
 * @param className {string} Additionnal CSS Classes
 * @param children {React.ReactNode}
 * @param customIcon {IconName | React.ReactNode } Icon name | children
 * @param status {ListIconStatus} Status success|error
 */
export default ListItem;
//# sourceMappingURL=ListItem.js.map